// extracted by mini-css-extract-plugin
export default {"toast":"toast-notification_toast__Kj4FV","shown":"toast-notification_shown__QpepU"};